<template>
  <b-container class="bv-example-row bv-example-row-flex-cols table-wrapper-1" fluid>
    <!--    <b-row-->
    <!--      align-v="center"-->
    <!--      class="filter-wrapper"-->
    <!--    >-->
    <!--      <b-col>-->
    <!--        <test-filter-component-->
    <!--          :status-filter.sync="statusFilter"-->
    <!--          :hospital-selected.sync="hospitalSelected"-->
    <!--          :direction-filter-selected.sync="directionFilterSelected"-->
    <!--        />-->
    <!--      </b-col>-->
    <!--    </b-row>-->
    <b-row>
      <b-table
        striped
        hover
        small
        outlined
        foot-clone
        bordered
        show-empty
        :current-page="currentPage"
        :per-page="perPage"
        :fields="fields"
        :items="itemsFilterComputed"
      >
        <!-- <template
          slot="no"
          slot-scope="data"
        >
          <div class="col-right">
            {{ $numeral(data.index +1).format('0,0[.]00') }}
          </div>
        </template>-->
        <template slot="hospital_name" slot-scope="data">
          <div class="col-left">{{ data.item.hospital_name }}</div>
        </template>
        <template slot="direction" slot-scope="data">
          <div class="col-left">{{ data.item.direction }}</div>
        </template>
        <template slot="created_at" slot-scope="data">
          <div class="col-center">{{ data.item.created_at }}</div>
        </template>
        <template slot="ln" slot-scope="data">
          <div class="col-right">{{ data.item.ln }}</div>
        </template>
        <template slot="test_name" slot-scope="data">
          <div class="col-left">{{ data.item.test_name }}</div>
        </template>
        <template slot="patient" slot-scope="data">
          <div class="col-left">{{ data.item.patient }}</div>
        </template>
        <template slot="spp" slot-scope="data">
          <div class="col-left">{{ data.item.spp }}</div>
        </template>
        <template slot="price" slot-scope="data">
          <div class="col-right">{{ $numeral(data.item.price).format('0,0[.]00') }}</div>
        </template>
        <template slot="FOOT_daily_number">
          <div class="col-right" />
        </template>
        <template slot="FOOT_hospital_name">
          <div class="col-left" />
        </template>
        <template slot="FOOT_direction">
          <div class="col-left" />
        </template>
        <template slot="FOOT_created_at">
          <div class="col-left" />
        </template>
        <template slot="FOOT_ln">
          <div class="col-left" />
        </template>
        <template slot="FOOT_test_name">
          <div class="col-left" />
        </template>
        <template slot="FOOT_patient">
          <div class="col-left" />
        </template>
        <template slot="FOOT_spp">
          <div class="col-right">รวม</div>
        </template>
        <template slot="FOOT_price">
          <div
            class="col-right"
            v-if="itemsFilterComputed"
          >{{ $numeral(itemsFilterComputed.reduce((a, b) => a + +b.price, 0).toFixed(2)).format('0,0[.]00') }}</div>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col cols="auto">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import testFilterComponent from "./testFilterComponent";
import { mapActions } from "vuex";
import * as moment from "moment";

export default {
  name: "TestTable",
  // components: {
  //   testFilterComponent
  // },
  props: {
    reportType: {
      required: true
    },
    itemsFilter: {
      required: true
    },
    itemsObject: {
      required: true
    },
    dateType: {
      required: true
    },
    fromDate: {
      required: true
    },
    toDate: {
      required: true
    },
    hospitalSelected: {
      required: true
    },
    statusFilter: {
      required: true
    },
    directionFilterSelected: {
      required: true
    },
    creditTypeSelected: {
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      perPage: 50,
      // hospitalSelected: null,
      // statusFilter: null,
      // directionFilterSelected: null,
      fields: [
        {
          key: "daily_number",
          label: "Daily Number"
        },
        {
          key: "hospital_name",
          label: "โรงพยาบาล"
        },
        // {
        //   key: "direction",
        //   label: "เส้นทาง"
        // },
        {
          key: "created_at",
          label: "วันที่"
        },
        {
          key: "ln",
          label: "LN"
        },
        {
          key: "patient",
          label: "Patient"
        },
        {
          key: "spp",
          label: "SPP"
        },
        {
          key: "test_name",
          label: "รายการตรวจ"
        },
        {
          key: "price",
          label: "จำนวนเงิน"
        }
      ]
    };
  },
  computed: {
    itemsFilterComputed: {
      get() {
        return this.itemsFilter;
      },
      set(value) {
        this.$emit("update:itemsFilter", value);
      }
    },
    totalRows() {
      return this.itemsFilterComputed.length;
    }
  },
  methods: {
    ...mapActions({
      filter: "Account/reportTestFilter"
    }),
    async filters() {
      // check input informed ?
      // let firstDate = new Date(
      //   this.fromDate.getFullYear(),
      //   this.fromDate.getMonth(),
      //   this.fromDate.getDate() + 1
      // );

      // let lastDate;
      // if (this.dateType === 'date') {
      // lastDate = new Date(
      //   this.toDate.getFullYear(),
      //   this.toDate.getMonth(),
      //   this.toDate.getDate() + 1
      // );
      // } else {
      //   lastDate = new Date(
      //   this.toDate.getFullYear(),
      //   this.toDate.getMonth() + 1,
      //   0
      // );
      // }
      this.$store.state.isLoading = true;
      let firstDate = moment(this.fromDate);
      let lastDate = moment(this.toDate);

      if (this.dateType === "date") {
        firstDate = firstDate.startOf("days");
        lastDate = lastDate.endOf("days");
      } else if (this.dateType === "month") {
        firstDate = firstDate.startOf("months");
        lastDate = lastDate.endOf("months");
      } else if (this.dateType === "year") {
        firstDate = firstDate.startOf("years");
        lastDate = lastDate.endOf("years");
      }
      firstDate = firstDate.unix();
      lastDate = lastDate.unix();

      let result = await this.filter({
        hospital_selected: this.hospitalSelected,
        status_filter: this.statusFilter,
        date_type: this.dateType,
        from_date: firstDate,
        to_date: lastDate,
        direction_filter_selected: this.directionFilterSelected,
        credit_type_selected: this.creditTypeSelected
      });

      if (result.success) {
        this.itemsFilterComputed = result.result;
        this.$emit("update:itemsObject", result);
        this.$store.state.isLoading = false;
      } else {
        this.$bvToast.toast(`${result.errors}`, {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          variant: "danger"
        });
        this.$store.state.isLoading = false;
      }
    }
  },
  watch: {
    // dateType() {
    //   if (this.reportType === "testReport") {
    //     this.filters();
    //   }
    // },
    // fromDate() {
    //   if (this.reportType === "testReport") {
    //     this.filters();
    //   }
    // },
    // toDate() {
    //   if (this.reportType === "testReport") {
    //     this.filters();
    //   }
    // },
    // hospitalSelected() {
    //   if (this.reportType === "testReport") {
    //     this.filters();
    //   }
    // },
    // statusFilter() {
    //   if (this.reportType === "testReport") {
    //     this.filters();
    //   }
    // },
    // directionFilterSelected() {
    //   if (this.reportType === "testReport") {
    //     this.filters();
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  background: #eaeced;
  padding: 0 1rem;
}

.table-wrapper-1 {
  padding: 0 3rem 3rem 3rem;
}
</style>
